import { createStore, combineReducers, applyMiddleware, Reducer } from "redux";
import thunk, { ThunkMiddleware } from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { RootState } from "./rootState";
import { appContextReducer } from "./appContext/reducer";
import { TypedUseSelectorHook, useDispatch as useReduxDispatch, useSelector as useReduxSelector } from "react-redux";

const rootReducer: Reducer<RootState> = combineReducers({
  appContext: appContextReducer
});

let middleware = applyMiddleware(thunk as ThunkMiddleware<RootState>);

if (process.env.NODE_ENV !== "production") {
  middleware = composeWithDevTools(middleware);
}

const initialState = {} as RootState;

export const store = createStore(rootReducer, initialState, middleware);

export const useDispatch = () => useReduxDispatch<typeof store.dispatch>();

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;
